import { ComponentStateTypes } from "components/common/ComponentState";
import Form from "components/common/form/Form";
import Input from "components/common/form/inputs/Input";
import FormActions from "components/common/form/partials/FormActions";
import Page from "components/common/page/Page";
import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { GetPersonTagQuery } from "types/graphql";
import { getTag, saveTag } from "types/person-types";
import useAppContext from "utilities/hooks/useAppContext";

type ModelType = NonNullable<GetPersonTagQuery['personTag']>;

const PersonTagFormPage = () => {
    const params = useParams<{id: string}>();
    const context = useAppContext();
    const [model, setModel] = useState<ModelType>({
        id: 0,
        name: '',
    });
    const [componentState, setComponentState] = useState<ComponentStateTypes>(params.id ? 'loading' : '');

    useEffect(() => {
        if (params.id && Number(params.id) > 0) {
            loadData();
        } else {
            setComponentState('');
        }
    }, []);

    const loadData = async () => {
        setComponentState('loading');
        try {
            const response = await getTag({id: Number(params.id)}, context.notify);
            setModel(response!);
            setComponentState('');
        } catch (e: any) {
            setComponentState('error');
        }
    }
    
    const onSubmit = async () => {
        setComponentState('loading');
        try {
            await saveTag(model, context.notify);
            setComponentState('success');
            context.navigate(-1);
        } catch (e: any) {
            setComponentState('error');
        }
    }

    return (
        <Page title="pages.people.tag.form" state={componentState}>
            <Form name="personTagFormPage" onSubmit={onSubmit}>
                <Input
                    name="name"
                    label="fields.name.name"
                    required
                    min={1}
                    max={20}
                    value={model.name}
                    onChange={(e) => setModel({...model, name: e || ''})}
                />
                <FormActions />
            </Form>
        </Page>
    );
};

export default PersonTagFormPage;
